<template>
  <div id="QrOrdersOilMakerByVariantChart"></div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

export default {
  name: "QrOrdersOilMakerByVariantChart",
  props: {
    chartData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      chart: null,
      noDataLabel: null,
      colors: ["#8FDCFF"],
    };
  },
  watch: {
    chartData: {
      handler(newData) {
        // console.log("Received chartData:", newData);
        this.updateChart(newData);
      },
      immediate: true,
    },
  },
  mounted() {
    // console.log("Creating Stacked Column Chart");
    this.createChart(this.chartData);
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  methods: {
    // createChart(data) {
    //   // console.log("Creating chart with data:", data);
    //   this.chart = am4core.create(
    //     "QrOrdersOilMakerByVariantChart",
    //     am4charts.XYChart
    //   );
    //   this.chart.data = data;

    //   let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
    //   categoryAxis.dataFields.category = "variant";
    //   categoryAxis.renderer.minGridDistance = 50;
    //   categoryAxis.renderer.grid.template.location = 0;

    //   let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
    //   valueAxis.min = 0;
    //   valueAxis.renderer.opposite = false;

    //   // this.noDataLabel = this.chart.tooltipContainer.createChild(am4core.Label);
    //   // this.noDataLabel.html = `<p style="font-weight: bold; font-size: 1.5rem;">No Data</p>`;
    //   // this.noDataLabel.align = "center";
    //   // this.noDataLabel.valign = "middle";
    //   // this.noDataLabel.horizontalCenter = "middle";
    //   // this.noDataLabel.verticalCenter = "middle";
    //   // this.noDataLabel.hide();

    //   if (!this.noDataLabel) {
    //     this.noDataLabel = this.chart.tooltipContainer.createChild(
    //       am4core.Label
    //     );
    //     this.noDataLabel.html = `<p style="font-weight: bold; font-size: 1.5rem;">No Data</p>`;
    //     this.noDataLabel.align = "center";
    //     this.noDataLabel.valign = "middle";
    //     this.noDataLabel.horizontalCenter = "middle";
    //     this.noDataLabel.verticalCenter = "middle";
    //   }

    //   this.createSeries(this.chart, "value", "Value", this.colors[0]);

    //   let cursor = new am4charts.XYCursor();
    //   this.chart.cursor = cursor;
    // },
    createChart(data) {
      if (this.chart) {
        this.chart.dispose();
      }

      this.chart = am4core.create("QrOrdersOilMakerByVariantChart", am4charts.XYChart);
      this.chart.data = data;

      let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "variant";
      categoryAxis.renderer.minGridDistance = 50;

      let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.min = 0;
      valueAxis.renderer.opposite = false;
      valueAxis.numberFormatter.numberFormat = "#";
      valueAxis.maxPrecision = 0;

      valueAxis.title.text = "Total";
      valueAxis.title.rotation = 270;
      valueAxis.title.align = "center";
      valueAxis.title.valign = "center";
      valueAxis.title.dy = 130;

      this.noDataLabel = this.chart.tooltipContainer.createChild(am4core.Label);
      this.noDataLabel.html = `<p style="font-weight: bold; font-size: 1.5rem;">No Data</p>`;
      this.noDataLabel.align = "center";
      this.noDataLabel.valign = "middle";
      this.noDataLabel.horizontalCenter = "middle";
      this.noDataLabel.verticalCenter = "middle";
      this.noDataLabel.hide();

      const hasData = data && data.some((item) => item.value && item.value > 0);
      if (!hasData) {
        this.noDataLabel.show();
        valueAxis.max = 1000;
        valueAxis.strictMinMax = true;
      }

      this.createSeries(this.chart, "value", "Value", this.colors[0]);

      if (this.chart.tooltip) {
        this.chart.tooltip.background.fill = am4core.color("#FFFFFF");
        this.chart.tooltip.background.stroke = am4core.color("#CCCCCC");
        this.chart.tooltip.background.strokeWidth = 1;
        this.chart.tooltip.background.cornerRadius = 4;
        this.chart.tooltip.getFillFromObject = false;
        this.chart.tooltip.label.fill = am4core.color("#000000");
      }

      let cursor = new am4charts.XYCursor();
      this.chart.cursor = cursor;
    },

    // updateChart(newData) {
    //   // console.log("Updating chart with data:", newData);

    //   if (!this.chart) {
    //     // console.error("Chart is not initialized");
    //     return;
    //   }

    //   if (!newData || newData.length === 0) {
    //     if (this.noDataLabel) {
    //       this.noDataLabel.show();
    //     }
    //     return;
    //   }

    //   if (this.noDataLabel) {
    //     this.noDataLabel.hide();
    //   }

    //   this.chart.series.clear();
    //   this.createSeries(this.chart, "value", "Value", this.colors[0]);

    //   this.chart.data = newData;
    //   this.chart.invalidateData();
    // },
    // updateChart(newData) {
    //   if (!this.chart) return;

    //   const hasData =
    //     newData && newData.some((item) => item.value && item.value > 0);

    //   if (!hasData) {
    //     if (this.noDataLabel) {
    //       this.noDataLabel.show();
    //     }
    //     this.chart.data = []; // clear the chart's data
    //     this.chart.series.clear(); // clear series so no leftover bars appear
    //     return;
    //   }

    //   if (this.noDataLabel) {
    //     this.noDataLabel.hide();
    //   }

    //   this.chart.series.clear();
    //   this.createSeries(this.chart, "value", "Value", this.colors[0]);

    //   this.chart.data = newData;
    //   this.chart.invalidateData();
    // },
    updateChart(newData) {
      if (!this.chart) return;

      const hasData = newData && newData.some((item) => item.value && item.value > 0);
      let valueAxis = this.chart.yAxes.getIndex(0);

      if (!hasData) {
        if (this.noDataLabel) {
          this.noDataLabel.show();
        }

        if (valueAxis) {
          valueAxis.max = 1000;
          valueAxis.strictMinMax = true;
        }
        this.chart.data = [];
        this.chart.series.clear();
        return;
      }

      if (this.noDataLabel) {
        this.noDataLabel.hide();
      }

      // Auto scale when there is data
      if (valueAxis) {
        valueAxis.max = undefined;
        valueAxis.strictMinMax = false;
      }

      this.chart.series.clear();
      this.createSeries(this.chart, "value", "Value", this.colors[0]);

      this.chart.data = newData;
      this.chart.invalidateData();
    },

    createSeries(chart, field, name, color) {
      let series = new am4charts.ColumnSeries();
      chart.series.push(series);
      series.dataFields.valueY = field;
      series.dataFields.categoryX = "variant";
      series.name = name;
      series.stacked = true;
      series.columns.template.width = am4core.percent(32);
      series.columns.template.tooltipText = "{name}: [bold]{valueY}[/]";
      series.fill = am4core.color(color);
      series.stroke = am4core.color(color);

      series.tooltip.background.fill = am4core.color("#FFFFFF");
      series.tooltip.background.stroke = am4core.color("#CCCCCC");
      series.tooltip.background.strokeWidth = 1;
      series.tooltip.background.cornerRadius = 4;
      series.tooltip.getFillFromObject = false;
      series.tooltip.label.fill = am4core.color("#000000");

      let columnTemplate = series.columns.template;
      columnTemplate.column.cornerRadiusTopLeft = 8;
      columnTemplate.column.cornerRadiusTopRight = 8;
      columnTemplate.innerRadius = 8;
    },
  },
};
</script>

<style>
#QrOrdersOilMakerByVariantChart {
  width: 100%;
  height: 320px;
}
</style>
